export class EnvioDeMailGenerico{
    Emails: string[];
    asuntoCorreo: string;
    cuerpoHtml: string;
}